import {
    initMenuTrigger,
    addHideScrolledMenuClass,
    initForm,
    googleMapInit,
    initLazyBg,
    initFooterVideo,
    initShow,
    smoothScrollTo
} from './functions';


// GLightbox NIE jest importowany statycznie, a potrzebny tylko
// na stronach z obrazkami-linkami. Ładowany dynamicznie (osobny chunk
// glightbox.min.js z paczki npm), gdy na stronie są elementy
// pasujące do selektora.
const LIGHTBOX_SELECTOR = ".glightbox, .wp-block-button.lightbox a, .wp-block-button a[href$='.mp4'], .wp-block-button a[href$='.webm'], .wp-block-button.lightbox a[href$='.jpeg'], .wp-block-button.lightbox a[href$='.png'], .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a";

const initLightbox = () => {
    if (!document.querySelector(LIGHTBOX_SELECTOR)) return;

    // JS i CSS lightboxa w jednym chunku — style wstrzykiwane przez
    // style-loader w momencie załadowania (nie ma ich w style.min.css)
    Promise.all([
        import(/* webpackChunkName: "glightbox" */ 'glightbox'),
        import(/* webpackChunkName: "glightbox" */ 'glightbox/dist/css/glightbox.min.css'),
    ]).then(([{ default: GLightbox }]) => {
        GLightbox({
            selector: LIGHTBOX_SELECTOR,
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });
    });
};


/**
 * Slidery (Swiper) — logika i importy Swipera siedzą w js/sliders.js,
 * ładowanym dynamicznie jako chunk swiper.min.js tylko wtedy, gdy na
 * stronie jest rotator lub blok galerii-slidera.
 */
const ROTATOR_SELECTOR = '.rotatorTop';
const GALLERY_SELECTOR = '.wp-block-avangardo-gallery__gallery.swiperUi';
const BLOCK_SELECTOR = '.blockSlider__slider';

const initSliders = () => {
    const rotators = document.querySelectorAll(ROTATOR_SELECTOR);
    const galleries = document.querySelectorAll(GALLERY_SELECTOR);
    const blocks = document.querySelectorAll(BLOCK_SELECTOR);
    if (!rotators.length && !galleries.length && !blocks.length) return;

    import(/* webpackChunkName: "swiper" */ './sliders').then(({ initRotator, initGallery, initBlockSlider }) => {
        rotators.forEach(initRotator);
        galleries.forEach(initGallery);
        blocks.forEach(initBlockSlider);
    });
};


/**
 * Efekty scrollowe (Lenis + GSAP ScrollTrigger) — chunk scroll-fx.min.js,
 * ładowany na każdej stronie (wygładzanie scrolla jest globalne).
 * Nie ładowany przy prefers-reduced-motion: strona zostaje wtedy na
 * natywnym scrollu, a obrazy paralaksy stoją normalnie (ich stan startowy
 * w CSS też jest bramkowany tą samą preferencją).
 */
const initScrollFx = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    import(/* webpackChunkName: "scroll-fx" */ './scroll-fx').then(({ initScrollFx }) => {
        initScrollFx();
    });
};


/**
 * Nawigacja i interakcje klikane — jedna delegacja na document
 * (odpowiednik dawnych handlerów jQuery, bez jQuery).
 */
const initClickHandlers = () => {
    document.addEventListener('click', (e) => {

        // strzałka "w dół" pod nagłówkiem podstrony
        const goDown = e.target.closest('.subpageHeader__goDown');
        if (goDown) smoothScrollTo(goDown, -200);

        // menu mobilne: rozwijanie podmenu (tylko < 1200px)
        const parentItem = e.target.closest('#primary-menu .menu-item-has-children');
        if (parentItem && window.innerWidth < 1200) {
            const back = document.querySelector('.mainHeader__menuBack');
            if (!parentItem.classList.contains('active')) {
                parentItem.classList.add('active');
                parentItem.parentNode.classList.add('activeParent');
                if (back) back.classList.add('show');
                const holder = document.querySelector('.mainHeader__menuHolder');
                if (holder) holder.scrollTop = 0;
            } else {
                parentItem.classList.remove('active');
                parentItem.parentNode.classList.remove('activeParent');
            }
        }

        // menu mobilne: przycisk "Powrót"
        if (e.target.closest('.mainHeader__menuBack')) {
            const parents = document.querySelectorAll('.activeParent');
            if (parents.length) parents[parents.length - 1].classList.remove('activeParent');
            const actives = document.querySelectorAll('#primary-menu .menu-item.active');
            if (actives.length) actives[actives.length - 1].classList.remove('active');
            if (document.querySelectorAll('#primary-menu .menu-item.active').length === 0) {
                const back = document.querySelector('.mainHeader__menuBack');
                if (back) back.classList.remove('show');
            }
        }

        // hamburger: reset rozwiniętych podmenu (toggle showMenu robi initMenuTrigger)
        if (e.target.closest('.menuTrigger')) {
            document.querySelectorAll('.activeParent').forEach((n) => n.classList.remove('activeParent'));
            document.querySelectorAll('#primary-menu .menu-item.active').forEach((n) => n.classList.remove('active'));
            const back = document.querySelector('.mainHeader__menuBack');
            if (back) back.classList.remove('show');
        }

        // płynny scroll do kotwic
        /* const anchor = e.target.closest('a[href^="#"]');
         if (anchor) {
             e.preventDefault();
             const target = anchor.getAttribute('href');
             if (target.length > 1) {
                 let targetEl = null;
                 try {
                     targetEl = document.querySelector(target);
                 } catch (err) { }
                 if (targetEl) smoothScrollTo(targetEl, 140);
             }
         }*/

        // taby atutów
        const atut = e.target.closest('.gAtuty__menuItem');
        if (atut) {
            document.querySelectorAll('.gAtuty__menuItem').forEach((n) => n.classList.remove('active'));
            atut.classList.add('active');
            document.querySelectorAll('.gAtuty__contentItem').forEach((n) => n.classList.remove('active'));
            const content = document.getElementById(atut.dataset.target);
            if (content) content.classList.add('active');
        }
    });
};

/**
 * Linki w menu z href "mobilny|desktopowy" — wybór wg szerokości okna.
 */
const initResponsiveMenuLinks = () => {
    const viewportWidth = window.innerWidth;
    document.querySelectorAll('#primary-menu a[href*="|"]').forEach((a) => {
        const parts = a.getAttribute('href').split('|');
        a.setAttribute('href', viewportWidth <= 782 ? parts[0] : parts[1]);
    });
};

/**
 * Wejście na stronę z #hash — doscrolluj z offsetem na sticky header.
 */
const initHashScroll = () => {
    if (!window.location.hash) return;
    window.setTimeout(() => {
        let targetEl = null;
        try {
            targetEl = document.querySelector(window.location.hash);
        } catch (err) { }
        if (targetEl) smoothScrollTo(targetEl, 140);
    }, 500);
};


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    // lazy load + jednorazowy start video w stopce
    initFooterVideo();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();

    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();

    //start - contact form
    initForm();

    googleMapInit();

    initClickHandlers();
    initResponsiveMenuLinks();
    initHashScroll();

    initSliders();
    initLightbox();
    initScrollFx();




}

document.addEventListener("DOMContentLoaded", mainApp, false);
